import { combineReducers } from 'redux-immutable'
import employeeCreateReducer from './employee-create-reducer'
import employeeListReducer from './employee-list-reducer'
import employeeEditReducer from './employee-edit-reducer'
import employeeGetReducer from './employee-get-reducer'
import employeeDeactivateReducer from './employee-deactivate-reducer'
import employeeUploadImageReducer from './employee-upload-image-reducer'
import employeeExportReducer from './employee-export-reducer'
import employeeImportReducer from './employee-import-reducer'
import employeeFavoriteReducer from './employee-favorite-reducer'
import employeeEditProfileReducer from './employee-edit-profile-reducer'
import employeeReducer from './employee-reducer'
import employeeCreateMovementReducer from './employee-create-movement-reducer'
import employeeEditMovementReducer from './employee-edit-movement-reducer'
import employeeDeleteMovementReducer from './employee-delete-movement-reducer'
import employeeEditPrivilegeReducer from './employee-edit-privilege-reducer'
import employeeManualReducer from './employee-manual-reducer'

export default combineReducers({
  employeeCreate: employeeCreateReducer,
  employeeList: employeeListReducer,
  employeeEdit: employeeEditReducer,
  employeeGet: employeeGetReducer,
  employeeDeactivate: employeeDeactivateReducer,
  employeeUploadImage: employeeUploadImageReducer,
  employeeExport: employeeExportReducer,
  employeeImport: employeeImportReducer,
  employeeFavorite: employeeFavoriteReducer,
  employeeEditProfile: employeeEditProfileReducer,
  employee: employeeReducer,
  employeeCreateMovement: employeeCreateMovementReducer,
  employeeEditMovement: employeeEditMovementReducer,
  employeeDeleteMovement: employeeDeleteMovementReducer,
  employeeEditPrivilege: employeeEditPrivilegeReducer,
  employeeManual: employeeManualReducer,
})



// WEBPACK FOOTER //
// ./src/reducers/employee/index.js